import {replaceNewlinesWithBreaks} from '../../../usecase/replaceNewlinesWithBreaks';

type Props = {
  employmentType: string;
  jobType: string;
  jobDescription: string;
  salary: string;
  benefits: string;
  workLocation?: string;
  educationSystem?: string;
  qualificationRequirements?: string;
  companyPageYearlyItem: CompanyPageYearlyItem[];
  contactUrl: string;
};

export type CompanyPageYearlyItem = {
  label: string;
  value: string;
};

// 実施要項
export const CompanyRecruitmentGuideTable: React.FC<Props> = ({
  employmentType,
  jobType,
  jobDescription,
  salary,
  benefits,
  workLocation,
  educationSystem,
  qualificationRequirements,
  companyPageYearlyItem,
  contactUrl,
}) => {
  return (
    <div className="pc:mt-8 p-16 pc:px-[256px] bg-white rounded-b-[12px] rounded-t-[4px] border-t-[1px] border-t-line-1 pc:border-t-[0px]">
      <table className="px-16 w-full hidden pc:table mt-12">
        <tbody>
          <tr>
            <th className="text-left font-bold w-[130px]">
              <div className="my-4 px-16 py-8">募集種別</div>
            </th>
            <td className="px-16">
              <div
                className="py-8 pl-16 whitespace-pre-wrap"
                dangerouslySetInnerHTML={{
                  __html: replaceNewlinesWithBreaks(employmentType),
                }}
              />
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold">
              <div className="my-4 px-16 py-8">募集職種</div>
            </th>
            <td className="px-16">
              <div
                className="py-8 pl-16 whitespace-pre-wrap"
                dangerouslySetInnerHTML={{
                  __html: replaceNewlinesWithBreaks(jobType),
                }}
              />
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold">
              <div className="my-4 px-16 py-8">仕事内容</div>
            </th>
            <td className="px-16">
              <div
                className="py-8 pl-16 whitespace-pre-wrap"
                dangerouslySetInnerHTML={{
                  __html: replaceNewlinesWithBreaks(jobDescription),
                }}
              />
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold">
              <div className="my-4 px-16 py-8">給与</div>
            </th>
            <td className="px-16">
              <div
                className="py-8 pl-16 whitespace-pre-wrap"
                dangerouslySetInnerHTML={{
                  __html: replaceNewlinesWithBreaks(salary),
                }}
              />
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold">
              <div className="my-4 px-16 py-8">諸手当</div>
            </th>
            <td className="px-16">
              <div
                className="py-8 pl-16 whitespace-pre-wrap"
                dangerouslySetInnerHTML={{
                  __html: replaceNewlinesWithBreaks(benefits),
                }}
              />
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold">
              <div className="my-4 px-16 py-8">勤務地</div>
            </th>
            <td className="px-16">
              <div
                className="py-8 pl-16 whitespace-pre-wrap"
                dangerouslySetInnerHTML={{
                  __html: replaceNewlinesWithBreaks(workLocation || ''),
                }}
              />
            </td>
          </tr>
          {educationSystem && (
            <tr>
              <th className="text-left font-bold">
                <div className="my-4 px-16 py-8">教育制度</div>
              </th>
              <td className="px-16">
                <div
                  className="py-8 pl-16 whitespace-pre-wrap"
                  dangerouslySetInnerHTML={{
                    __html: replaceNewlinesWithBreaks(educationSystem),
                  }}
                />
              </td>
            </tr>
          )}
          {qualificationRequirements && (
            <tr>
              <th className="text-left font-bold">
                <div className="my-4 px-16 py-8">応募資格</div>
              </th>
              <td className="px-16">
                <div
                  className="py-8 pl-16 whitespace-pre-wrap"
                  dangerouslySetInnerHTML={{
                    __html: replaceNewlinesWithBreaks(
                      qualificationRequirements,
                    ),
                  }}
                />
              </td>
            </tr>
          )}
          {companyPageYearlyItem.map((item, i) => (
            <tr key={i}>
              <th className="text-left font-bold">
                <div className="my-4 px-16 py-8">{item.label}</div>
              </th>
              <td className="px-16">
                <div
                  className="py-8 pl-16 whitespace-pre-wrap"
                  dangerouslySetInnerHTML={{
                    __html: replaceNewlinesWithBreaks(item.value),
                  }}
                />
              </td>
            </tr>
          ))}
          <tr>
            <th className="text-left font-bold">
              <div className="my-4 px-16 py-8">お問い合わせ</div>
            </th>
            <td className="px-16">
              <div
                className="py-8 pl-16 whitespace-pre-wrap"
                dangerouslySetInnerHTML={{
                  __html: replaceNewlinesWithBreaks(contactUrl),
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
      {/* SP */}
      <div className="display pc:hidden sm:px-0">
        <div>
          <h3 className="text-lg font-bold leading-none pb-8">募集種別</h3>
          <p
            className="pl-8"
            dangerouslySetInnerHTML={{
              __html: replaceNewlinesWithBreaks(employmentType),
            }}
          />
        </div>
        <div>
          <h3 className="text-lg font-bold leading-none pt-20 pb-8">
            募集職種
          </h3>
          <p
            dangerouslySetInnerHTML={{
              __html: replaceNewlinesWithBreaks(jobType),
            }}
          />
        </div>
        <div>
          <h3 className="text-lg font-bold leading-none pt-20 pb-8">
            仕事内容
          </h3>
          <p
            className="pl-8 whitespace-pre-wrap"
            dangerouslySetInnerHTML={{
              __html: replaceNewlinesWithBreaks(jobDescription),
            }}
          />
        </div>
        <div>
          <h3 className="text-lg font-bold leading-none pt-20 pb-8">給与</h3>
          <p
            className="pl-8"
            dangerouslySetInnerHTML={{
              __html: replaceNewlinesWithBreaks(salary),
            }}
          />
        </div>
        <div>
          <h3 className="text-lg font-bold leading-none pt-20 pb-8">諸手当</h3>
          <p
            className="pl-8"
            dangerouslySetInnerHTML={{
              __html: replaceNewlinesWithBreaks(benefits),
            }}
          />
        </div>
        <div>
          <h3 className="text-lg font-bold leading-none pt-20 pb-8">勤務地</h3>
          <p
            className="pl-8"
            dangerouslySetInnerHTML={{
              __html: replaceNewlinesWithBreaks(workLocation || ''),
            }}
          />
        </div>
        {educationSystem && (
          <div>
            <h3 className="text-lg font-bold leading-none pt-20 pb-8">
              教育制度
            </h3>
            <p
              className="pl-8"
              dangerouslySetInnerHTML={{
                __html: replaceNewlinesWithBreaks(educationSystem),
              }}
            />
          </div>
        )}
        {qualificationRequirements && (
          <div>
            <h3 className="text-lg font-bold leading-none pt-20 pb-8">
              応募資格
            </h3>
            <p
              className="pl-8"
              dangerouslySetInnerHTML={{
                __html: replaceNewlinesWithBreaks(qualificationRequirements),
              }}
            />
          </div>
        )}
        {companyPageYearlyItem.map((item, i) => (
          <div key={i}>
            <h3 className="text-lg font-bold leading-none pt-20 pb-8">
              {item.label}
            </h3>
            <p
              className="pl-8"
              dangerouslySetInnerHTML={{
                __html: replaceNewlinesWithBreaks(item.value),
              }}
            />
          </div>
        ))}
        <div>
          <h3 className="text-lg font-bold leading-none pt-20 pb-8">
            お問い合わせ
          </h3>
          <p
            className="pl-8"
            dangerouslySetInnerHTML={{
              __html: replaceNewlinesWithBreaks(contactUrl),
            }}
          />
        </div>
      </div>
    </div>
  );
};
